module.exports = __webpack_public_path__ + "img/bacteria.5600b61e.png";